import React, { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/SendEmailPOpopup.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SendEmailPOpopup = (props) => {
  const [loading, setLoading] = useState(false);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add Purchasing Order").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);
  return (
    <>
      <Modal
        {...props}
        id="asc_purch_modal"
        dialogClassName="custum_projectPop"
        // size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {/* Modal heading */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h4>Centered Modal</h4> */}
          <p className="purch_textPO px-5 mx-4">
            {/* The Purchase */}
            {t("The Purchase")}{" "}
            <span className="poOrderid">
              {/* Order ID  */}
              {t("Order ID")} {props.orderCode}{" "}
            </span>
            {/* was created successfully */}
            {t("was created successfully")}{" "}
            {props.toggleActive && (
              <p>
                {/* and sent to the supplier by email. */}
                {t("and sent to the supplier by email.")}
              </p>
            )}
          </p>
          <p className="purch_textPO w-75 pt-3 px-5 mx-5">
            {/* Do you want to add another Purchase Order? */}
            {t("Do you want to add another Purchase Order?")}
          </p>
        </Modal.Body>
        <Modal.Footer className="pt-0 mt-">
          <button className="asc_purch_no" onClick={props.handleCancel}>
            {/* No */}
            {t("No ")}
          </button>

          {/* <Button onClick={props.handleDelete}>yes</Button> */}
          <button className="asc_purch_yes" onClick={props.onHide}>
            {/* Add */}
            {t("Add")}
            {props.loading === true && (
              <div
                className="spinner-border spinner-border-sm ms-2"
                role="status"
              ></div>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* <Button variant="primary" onClick={handleShow}>
                Launch demo modal
            </Button>

            <Modal show={show} onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </>
  );
};

export default SendEmailPOpopup;
